module.exports = __webpack_public_path__ + "static/cricket-a05367f9d03fb3e7392bf1eaa01a687f.png";